import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';

import { Modal } from '../../components';
import CreateEditEventForm, {
  prepareEventDataForSubmit,
  prepareInitialValuesFromEvent,
} from '../../forms/CreateEditEventForm';

import css from './CreateEditEventModal.module.css';

const CreateEditEventModal = props => {
  const {
    className,
    rootClassName,
    id,
    intl,
    isOpen,
    onClose,
    onSubmit,
    onManageDisableScrolling,
    event,
    initialDate,
    submitInProgress,
    submitError,
    participantOptions,
    onSearchParticipants,
    onGenerateMeeting,
  } = props;

  const isEditMode = !!event;

  // Prepare initial values
  let initialValues = prepareInitialValuesFromEvent(event);

  // If initialDate is provided (from clicking on calendar), pre-fill the start/end date
  if (!event && initialDate) {
    const startDate = new Date(initialDate);
    initialValues = {
      ...initialValues,
      startDate: { date: startDate },
      endDate: { date: startDate },
    };
  }

  const handleSubmit = values => {
    const eventData = prepareEventDataForSubmit(values, event?.id);
    onSubmit(eventData);
  };

  const handleCancel = () => {
    onClose();
  };

  const classes = classNames(rootClassName || css.root, className);

  const titleMessageId = isEditMode
    ? 'CreateEditEventModal.editTitle'
    : 'CreateEditEventModal.createTitle';

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <h2 className={css.modalTitle}>
        <FormattedMessage id={titleMessageId} />
      </h2>

      <CreateEditEventForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        initialValues={initialValues}
        isEditMode={isEditMode}
        submitInProgress={submitInProgress}
        formError={submitError}
        participantOptions={participantOptions}
        onSearchParticipants={onSearchParticipants}
        onGenerateMeeting={onGenerateMeeting}
      />
    </Modal>
  );
};

const { bool, func, object, string, instanceOf } = PropTypes;

CreateEditEventModal.defaultProps = {
  className: null,
  rootClassName: null,
  event: null,
  initialDate: null,
  submitInProgress: false,
  submitError: null,
  onManageDisableScrolling: () => {},
  participantOptions: [],
  onSearchParticipants: null,
  onGenerateMeeting: null,
};

CreateEditEventModal.propTypes = {
  className: string,
  rootClassName: string,
  id: string.isRequired,
  intl: intlShape.isRequired,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onSubmit: func.isRequired,
  onManageDisableScrolling: func,
  event: object, // Existing event for edit mode
  initialDate: instanceOf(Date), // Pre-fill date when clicking on calendar
  submitInProgress: bool,
  submitError: object,
  participantOptions: PropTypes.array,
  onSearchParticipants: PropTypes.func,
  onGenerateMeeting: func,
};

export default injectIntl(CreateEditEventModal);
